export const STEP_REQUIREMENT = 0;
export const STEP_CHARGE = 1;

export const additionalRequirementFields = {
  Product_PlanoImage: {
    fieldDisplayName: 'Planogram Image',
    fieldName: 'Product_PlanoImage',
  },

  Product_AdditionalImage: {
    fieldDisplayName: 'Additional Image',
    fieldName: 'Product_AdditionalImage',
  },

  Product_MarketingImage: {
    fieldDisplayName: 'Marketing Image',
    fieldName: 'Product_MarketingImage',
  },

  Product_Document: {
    fieldDisplayName: 'Document',
    fieldName: 'Product_Document',
  },

  Product_AnyImage: {
    fieldDisplayName: 'Total Image',
    fieldName: 'Product_AnyImage',
  },

  Product_Brand: {
    fieldDisplayName: 'Product Brand',
    fieldName: 'Product_Brand',
  },
  Product_UpcGtin: {
    fieldDisplayName: 'At least one UPC/GTIN field',
    fieldName: 'Product_UpcGtin',
  },
};
